import { createContext } from 'react'

const EditIssueContext = createContext('')

export default EditIssueContext
